export enum EVENT_SCHEDULE_TYPE {
  PAST = 'past',
  UPCOMING = 'upcoming',
}
